import React, { useContext, useRef } from 'react';
import { formatString } from 'typescript-string-operations';
import { LanguageContextData } from './types';
import { FaInfoCircle } from 'react-icons/fa';
import { textValues, LanguageContext } from './utils';

interface HeaderProps {
  step: number,
  maxStep: number
};

const Header = ({ step, maxStep }: HeaderProps) => {
  const { language } = useContext<LanguageContextData>(LanguageContext);
  const dialogRef = useRef<HTMLDialogElement>(null);
  return (
    <>
      <div className='row' style={{ marginBottom: '20px' }}>
        <button onClick={ (e) => { e.preventDefault(); dialogRef.current?.show(); } }>{ textValues[language]['help'] }&nbsp;<FaInfoCircle /></button>
        <span className='right'>{ formatString(textValues[language]['step'], step, maxStep) }</span>
      </div>
      <dialog className='dialog' ref={ dialogRef } onClick={ (e) => dialogRef.current?.close() }>
        <div className='dialogContent' onClick={ (e) => e.stopPropagation() }>
          <span dangerouslySetInnerHTML={{ __html: textValues[language]['helpText'] }} />
          <div className='row'>
            &nbsp;
            <button onClick={ (e) => { e.preventDefault(); dialogRef.current?.close() } }>{ textValues[language]['helpButton'] }</button>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default Header;